// **********************************************************
//  News section
// **********************************************************
/* eslint-disable */
$(function () {


  setTimeout(function () {

    $('.news-card').matchHeight({
      property: 'min-height',
    });

    //  news section isotop
    var $grid = $('.news-grid').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer'
      }
    });

    $('[data-filter]').on('click', function (e) {
      if ($('.news-grid').length) {
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({
          filter: filterValue
        });

        if ($('.news-grid').find(filterValue).length) {
          $('.news-grid__load-more').show();
        } else {
          $('.news-grid__load-more').hide();
        }

        $(this).parents('.categories-list__item').siblings().removeClass('is-active');
        $(this).parents('.categories-list__item').addClass('is-active');

        $('html, body').animate({
          scrollTop: $(".news-grid").offset().top - $('.site-header').outerHeight() - 40
        }, 1000);

        e.preventDefault();
      }
    });

  }, 300);

  $('.categories-list__title').on('click', function () {
    if (windowWidth() < 993) {
      $(this).parents('.categories-list').toggleClass('is-open').find('ul').slideToggle('fast');
    }
  });
});
/* eslint-enable */
